import { OAuthError, RedirectLoginOptions } from '@auth0/auth0-react'

import { callbackSlugs } from './config'

const isOAuthError = (error?: Error): error is OAuthError =>
  error instanceof Error && 'error' in error && 'error_description' in error

export const isUserBlockedError = (error?: Error): boolean =>
  isOAuthError(error) &&
  error.error === 'unauthorized' &&
  error.error_description === 'user is blocked'

export const isInvalidStateError = (error?: Error): boolean =>
  !!error && error.message === 'Invalid state'

export const getLoginCallbackUrl = (): string => {
  return typeof window !== 'undefined' ? `${window.location.origin}/${callbackSlugs.login}` : ''
}

export const mergeLoginWithRedirectOptions = (
  options?: RedirectLoginOptions,
): RedirectLoginOptions => {
  const optionsObj = options || {}
  return {
    ...optionsObj,
    redirectUri: getLoginCallbackUrl(),
  }
}
